import React, { useContext, useEffect, useMemo, useState } from "react"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Label,
  Tooltip,
  Spinner,
} from "reactstrap"
import { DataContext } from "../../context/dataContext"
import toast from "react-hot-toast"
import moment from "moment"
import apiHandler from "../../common/config/apiHandler"
import IncompleteBooking from "../../common/config/incomplete-booking"
import Loader from "../../components/Loader/loader"
import CompleteBooking from "../../common/config/complete-booking"
import createIntent from "../../common/config/createIntent"
import SendEmailModal from "./sendEmailForPayment"
import { useNavigate } from "react-router-dom"
import { inComingIncompleteBooking } from "../../common/config/socket.service"
import CreateNotes from "./Createnote"
import StripeElement from "../../components/Stripe/StripeElement"
import domainUrl from "../../common/config/domainUrl"
import DatePicker from "react-datepicker"
const IncompleteBookingForm = ({ isOpen, toggle, setIncompleteModalOpen }) => {
  const navigate = useNavigate()
  const {
    token,
    public_key,
    bookingDetails,
    fetchAirports,
    fetchCompanies,
    fetchSites,
    airports,
    subscribeKey,
    setSubscribeKey,
    fetchSubscribeKey,
    calculateTotalAmount,
  } = useContext(DataContext)
  const [loadingQuote, setLoadingQuote] = useState(false)

  const [formData, setFormData] = useState({
    site_id: "",
    company_id: "",
    airport: "",
    product: "",
    dropOffDate: "",
    dropOffTime: "",
    returnDate: "",
    returnTime: "",
    title: "",
    firstName: "",
    lastName: "",
    contactMobile: "",
    email: "",
    depTerminal: "",
    depFlight: "",
    arrTerminal: "",
    arrFlight: "",
    carMake: "",
    carModel: "",
    carColor: "",
    carReg: "",
    quoteAmount: "",
    extraCharges: "",
    discount: "",
    promoCode: "",
    sms: false,
    cancellation: false,
    bookingFee: "",
    totalAmount: "",
    paymentMethod: "",
    no_of_peoples: "",
    company_email: true,
    customer_email: true,
  })

  const [quoteData, setQuoteData] = useState({})
  const [totalAmountDetail, setTotalAmountDetail] = useState({})
  const [extraCharges, setExtraCharges] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [newTotalAmount, setNewTotalAmount] = useState(0)

  const [tooltipOpenSms, setTooltipOpenSms] = useState(false)
  const [tooltipOpenCancellation, setTooltipOpenCancellation] = useState(false)
  const [availableCompanies, setAvailableCompanies] = useState([])
  const [loading, setLoading] = useState(true)
  const [discountCode, setDiscountCode] = useState("")

  const [paymentOption, setPaymentOption] = useState("")
  const [payment_intent, setPayment_Intent] = useState("")
  const [transactionID, setTransactionID] = useState("")
  const [clientSecret, setClientSecret] = useState("")
  const [loadingPayment, setLoadingPayment] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [updateLoading, setUpdateLoading] = useState(false)

  const [apiTag, setApiTag] = useState(null)

  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false)

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const getColStyle = defaultWidth => ({
    width: isMobile ? "100%" : defaultWidth,
    marginBottom: isMobile ? "10px" : "0",
  })

  const handleSendEmailToggle = () => {
    setIsEmailModalOpen(!isEmailModalOpen)
  }
  useEffect(() => {
    if (subscribeKey) {
      fetchAirports()
      fetchCompanies()
      fetchSites()
    }
  }, [])
  const toggleSmsTooltip = () => setTooltipOpenSms(!tooltipOpenSms)
  const toggleCancellationTooltip = () =>
    setTooltipOpenCancellation(!tooltipOpenCancellation)

  // useEffect(() => {
  //   if (
  //     bookingDetails &&
  //     bookingDetails?.bookingDetails &&
  //     bookingDetails?.bookingDetails.length > 0
  //   ) {
  //     const detail = bookingDetails?.bookingDetails[0] || ""
  //     const initialAirport = detail.airport?.code || ""
  //     // Start Total amount //
  //     const AmountDetail = {
  //       cancellation_charges:
  //         detail?.cancellation_status == "1"
  //           ? parseFloat(detail?.payment?.cancellation_charges) || 0
  //           : 0,
  //       sms_charges:
  //         detail?.sms_confirmation == "1"
  //           ? parseFloat(detail?.payment?.sms_charges) || 0
  //           : 0,
  //       admin_charges: parseFloat(detail?.payment?.admin_charges) || 0,
  //       discount: parseFloat(detail?.payment?.discount) || 0,
  //       amount:
  //         parseFloat(detail?.payment?.amount) +
  //           parseFloat(detail?.payment?.discount) || 0,
  //       levy_charges: parseFloat(detail?.payment?.levy_charges) || 0,
  //       extra_charges: parseFloat(detail?.payment?.extra_charges) || 0,
  //     }
  //     setTotalAmountDetail(prev => {
  //       const updatedAmountDetail = {
  //         ...prev,
  //         ...AmountDetail,
  //       }
  //       // const totalCalculate = calculateTotalAmount(updatedAmountDetail)
  //       // setNewTotalAmount(totalCalculate)

  //       return updatedAmountDetail
  //     })

  //     // End Total amount //
  //     setFormData(prevState => ({
  //       ...prevState,
  //       ...detail,
  //       site_id: bookingDetails?.site?.id,
  //       airport: initialAirport,
  //       product: detail?.company_id || "",
  //       dropOffDate:
  //         moment(detail.departure_date, "YYYY-MM-DD").format("DD/MM/YYYY") ||
  //         "",
  //       dropOffTime:
  //         moment(detail.departure_time, "HH:mm:ss").format("HH:mm") || "",
  //       returnDate:
  //         moment(detail.arrival_date, "YYYY-MM-DD").format("DD/MM/YYYY") || "",
  //       returnTime:
  //         moment(detail.arrival_time, "HH:mm:ss").format("HH:mm") || "",
  //       title: detail.customer?.title || "",
  //       site_id: bookingDetails?.site?.id,
  //       firstName: detail.customer?.first_name || "",
  //       lastName: detail.customer?.last_name || "",
  //       contactMobile: detail.customer?.contact_no || "",
  //       email: detail.customer?.email || "",
  //       depTerminal: detail.departure_terminal || "",
  //       depFlight: detail.departure_flight_no || "",
  //       arrTerminal: detail.arrival_terminal || "",
  //       arrFlight: detail.arrival_flight_no || "",
  //       carMake: detail.vehicle?.make || "",
  //       carModel: detail.vehicle?.model || "",
  //       carColor: detail.vehicle?.color || "",
  //       carReg: detail.vehicle?.reg_no || "",
  //       quoteAmount: detail.payment?.amount || "",
  //       extraCharges: bookingDetails?.site?.amend_charge || "",
  //       no_of_peoples: detail?.no_of_peoples || 0,
  //       discount: detail?.payment?.discount || "",
  //       promoCode:
  //         detail.payment?.discount_code == 0
  //           ? ""
  //           : detail.payment?.discount_code || "",
  //       sms: detail?.sms_confirmation == "1" ? true : false,
  //       cancellation: detail?.cancellation_status == "1" ? true : false,
  //       bookingFee: detail.payment?.admin_charges || "",
  //       paymentMethod: detail.payment.type || "",
  //     }))
  //     setDiscountCode(detail?.discount_code)
  //     setExtraCharges(Number(detail?.company?.extra_amount))
  //     setApiTag(detail?.company?.sku_tag)

  //     if (initialAirport) {
  //       handleAirportChange({ target: { value: initialAirport } })
  //     }
  //   }
  // }, [bookingDetails])

  useEffect(() => {
    if (
      bookingDetails &&
      bookingDetails?.bookingDetails &&
      bookingDetails?.bookingDetails.length > 0
    ) {
      const detail = bookingDetails?.bookingDetails[0] || ""
      const initialAirport = detail.airport?.code || ""

      // Start Total amount //
      const AmountDetail = {
        cancellation_charges:
          detail?.cancellation_status == "1"
            ? parseFloat(detail?.payment?.cancellation_charges) || 0
            : 0,
        sms_charges:
          detail?.sms_confirmation == "1"
            ? parseFloat(detail?.payment?.sms_charges) || 0
            : 0,
        admin_charges: parseFloat(detail?.payment?.admin_charges) || 0,
        discount: parseFloat(detail?.payment?.discount) || 0,
        amount: parseFloat(detail?.payment?.amount) || 0,
        levy_charges: parseFloat(detail?.payment?.levy_charges) || 0,
        extra_charges: parseFloat(detail?.payment?.extra_charges) || 0,
      }

      const totalAmount =
        AmountDetail.amount + AmountDetail.extra_charges - AmountDetail.discount

      setTotalAmountDetail(prev => {
        const updatedAmountDetail = {
          ...prev,
          ...AmountDetail,
        }
        return updatedAmountDetail
      })

      setTotalAmount(totalAmount)

      setFormData(prevState => ({
        ...prevState,
        ...detail,
        site_id: bookingDetails?.site?.id,
        airport: initialAirport,
        product: detail?.company_id || "",
        dropOffDate:
          moment(detail.departure_date, "YYYY-MM-DD").format("DD/MM/YYYY") ||
          "",
        dropOffTime:
          moment(detail.departure_time, "HH:mm:ss").format("HH:mm") || "",
        returnDate:
          moment(detail.arrival_date, "YYYY-MM-DD").format("DD/MM/YYYY") || "",
        returnTime:
          moment(detail.arrival_time, "HH:mm:ss").format("HH:mm") || "",
        title: detail.customer?.title || "",
        firstName: detail.customer?.first_name || "",
        lastName: detail.customer?.last_name || "",
        contactMobile: detail.customer?.contact_no || "",
        email: detail.customer?.email || "",
        depTerminal: detail.departure_terminal || "",
        depFlight: detail.departure_flight_no || "",
        arrTerminal: detail.arrival_terminal || "",
        arrFlight: detail.arrival_flight_no || "",
        carMake: detail.vehicle?.make || "",
        carModel: detail.vehicle?.model || "",
        carColor: detail.vehicle?.color || "",
        carReg: detail.vehicle?.reg_no || "",
        quoteAmount: detail.payment?.amount || "",
        extraCharges: bookingDetails?.site?.amend_charge || 0,
        no_of_peoples: detail?.no_of_peoples || 0,
        discount: detail?.payment?.discount || 0,
        promoCode:
          detail.payment?.discount_code == 0
            ? ""
            : detail.payment?.discount_code || "",
        sms: detail?.sms_confirmation == "1" ? true : false,
        cancellation: detail?.cancellation_status == "1" ? true : false,
        bookingFee: detail.payment?.admin_charges || 0,
        paymentMethod: detail.payment.type || "",
      }))

      setDiscountCode(detail?.discount_code)
      setExtraCharges(Number(detail?.company?.extra_amount) || 0)
      setApiTag(detail?.company?.sku_tag)

      if (initialAirport) {
        handleAirportChange({ target: { value: initialAirport } })
      }
    }
  }, [bookingDetails])

  useEffect(() => {
    const totalCalculate = calculateTotalAmount(totalAmountDetail)
    setTotalAmount(totalCalculate)
  }, [totalAmountDetail])

  const handleCheckboxChange = e => {
    const { name, checked } = e.target

    setFormData(prevData => {
      const updatedValue = !prevData[name]

      const smsCharge = parseFloat(bookingDetails?.site?.sms_charge || 0)
      const cancelCharge = parseFloat(
        bookingDetails?.site?.cancellation_charge || 0
      )

      let updatedBaseAmount = Number(totalAmount)
      if (name === "sms") {
        updatedBaseAmount = updatedValue
          ? updatedBaseAmount + smsCharge
          : updatedBaseAmount - smsCharge
      }

      if (name === "cancellation") {
        updatedBaseAmount = updatedValue
          ? updatedBaseAmount + cancelCharge
          : updatedBaseAmount - cancelCharge
      }

      setTotalAmount(updatedBaseAmount)

      return {
        ...prevData,
        [name]: updatedValue,
      }
    })
  }

  useEffect(() => {
    if (paymentOption == "stripe-dashboard") {
      const currentDetail = bookingDetails?.bookingDetails?.find(
        detail => detail?.is_current === true || detail?.is_current === 1
      )

      setTransactionID(currentDetail?.payment?.transaction_id)
    }
  }, [paymentOption])

  useEffect(() => {
    if (bookingDetails) {
      fetchSubscribeKey(apiTag, bookingDetails?.site_id)
    }
  }, [bookingDetails])

  useEffect(() => {
    if (subscribeKey && formData?.airport) {
      fetchCompaniesById(formData?.airport)
    }
  }, [subscribeKey, formData?.airport])

  const fetchCompaniesById = async airportCode => {
    try {
      const token = localStorage.getItem("token")
      if (token && subscribeKey) {
        const response = await apiHandler({
          endpoint: `/backend/companies/getCompaniesByAirportId?airport_code=${airportCode}&key=${subscribeKey}`,
          method: "GET",
          options: {
            "x-access-token": token,
          },
        })

        if (response?.code === 200) {
          setAvailableCompanies(response?.data?.rows[0]?.companies || [])
          setLoading(false)
        } else {
          toast.error(
            response?.message ||
              "Failed to fetch companies. Please try again later."
          )
        }
      }
    } catch (error) {
      console.error("Error fetching companies:", error)
      toast.error("Network error occurred while fetching companies.")
    }
  }

  const handleChange = e => {
    const { name, value, type, checked } = e.target
    if (name === "extraCharges") {
      const newValue = Math.max(0, parseFloat(value) || 0)
      setExtraCharges(newValue)
      setTotalAmount(totalAmount + newValue)
      setFormData(prevState => ({
        ...prevState,
        extraCharges: newValue,
      }))
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: type === "checkbox" ? checked : value,
      }))
    }
  }

  const handleAirportChange = e => {
    const selectedAirportId = e.target.value
    setFormData(prevState => ({
      ...prevState,
      airport: selectedAirportId,
      product: formData?.company_id,
    }))
  }

  const handleGetQuote = async () => {
    const {
      dropOffDate,
      dropOffTime,
      returnDate,
      returnTime,
      site_id,
      airport,
      company_id,
    } = formData

    if (!dropOffDate || !dropOffTime || !returnDate || !returnTime) {
      toast.error(
        "Please fill in all date and time fields before getting a quote."
      )
      return
    }
    if (!company_id) {
      toast.error("Please fill Company Option")
      return
    }

    setLoadingQuote(true)
    try {
      const params = new URLSearchParams({
        site_id: bookingDetails?.site_id,
        airport,
        departure: moment(
          `${dropOffDate} ${dropOffTime}`,
          "DD-MM-YYYY HH:mm"
        ).format("DD-MM-YYYY HH:mm"),
        arrival: moment(
          `${returnDate} ${returnTime}`,
          "DD-MM-YYYY HH:mm"
        ).format("DD-MM-YYYY HH:mm"),
        company_id: formData?.company_id,
        discount_code: formData?.promoCode,
      })

      const response = await apiHandler({
        endpoint2: `/extendProduct?${params.toString()}`,
        method: "GET",
      })

      if (response?.response_code === 200) {
        setTotalAmountDetail(prev => {
          const updatedDetail = {
            ...prev,
            discount: parseFloat(response?.data?.discount) || 0,
            amount: parseFloat(response?.data?.price_before_discount) || 0,
            extra_charges: 0,
          }
          const totalCalculate = calculateTotalAmount(updatedDetail)
          setTotalAmount(totalCalculate)

          return updatedDetail
        })

        setDiscountCode(formData?.promoCode)
        // setFormData({
        //   ...formData,
        //   quoteAmount: response?.data?.price,
        //   discount: response?.data?.discount,
        // })
        setQuoteData(response?.data)
      } else {
        toast.error(
          response?.message || "Failed to fetch quote. Please try again later."
        )
      }
    } catch (error) {
      console.error("Error fetching quote:", error)
      alert("Network error occurred while fetching the quote.")
    } finally {
      setLoadingQuote(false)
    }
  }

  const handleUpdateIncomplete = async () => {
    const user = JSON.parse(localStorage.getItem("user"))
    setUpdateLoading(true)

    try {
      const incompleteResponse = await IncompleteBooking({
        key: subscribeKey,
        reference_no: bookingDetails?.reference_no,
        company_id: formData?.company_id,
        title: formData?.title,
        first_name: formData?.firstName,
        last_name: formData?.lastName,
        email: formData?.email,
        contact_no: formData?.contactMobile,
        departure: moment(
          `${formData?.dropOffDate} ${formData?.dropOffTime}`,
          "DD-MM-YYYY HH:mm"
        ).format("DD-MM-YYYY HH:mm"),
        arrival: moment(
          `${formData?.returnDate} ${formData?.returnTime}`,
          "DD-MM-YYYY HH:mm"
        ).format("DD-MM-YYYY HH:mm"),
        departure_terminal: formData?.depTerminal,
        departure_flight_no: formData?.depFlight,
        arrival_terminal: formData?.arrTerminal,
        arrival_flight_no: formData?.arrFlight,
        no_of_peoples: String(formData?.no_of_peoples),
        make: formData?.carMake,
        model: formData?.carModel,
        color: formData?.carColor,
        reg_no: formData?.carReg,
        amount: quoteData?.price_before_discount
          ? quoteData?.price_before_discount
          : formData?.quoteAmount,
        discount: quoteData?.discount
          ? quoteData?.discount
          : totalAmountDetail?.discount,
        discount_code: formData?.promoCode,
        admin_charges: formData?.bookingFee,
        extar_amount: extraCharges || 0,
        sms_confirmation: formData?.sms ? "1" : "0",
        cancellation_status: formData?.cancellation ? "1" : "0",
        user_id: String(user?.id),
      })
      if (incompleteResponse?.response_code == 200) {
        setNewTotalAmount(totalAmount)
        toast.success(incompleteResponse?.data)
        setUpdateLoading(false)
      } else {
        toast.error(incompleteResponse?.data)
        setUpdateLoading(false)
      }
    } catch (error) {
      toast.error(error?.message)
      setUpdateLoading(false)
      console.log(error)
    }
  }

  const handleCreateIntent = async () => {
    if (!subscribeKey) return

    setLoadingPayment(true)
    // const amountInCents = Math.round(totalAmount * 100 || 0)

    

    try {
         const params = {
          key: subscribeKey,
          amount: totalAmount.toFixed(2),
          description: bookingDetails?.multi_mode,
              };
       
              if (formData?.company?.sku_tag === "fhr") {
                params.api_tag = formData?.company?.sku_tag;
              }
        
              const paymentIntentResponse = await createIntent(params);
 

      if (paymentIntentResponse?.client_secret) {
        setClientSecret(paymentIntentResponse.client_secret)
        setPayment_Intent(paymentIntentResponse.payment_intent)
      } else {
        alert("Failed to create payment intent. Please try again.")
      }
    } catch (error) {
      console.error("Payment error:", error)
      alert(
        "Error creating payment intent. Please try again. Error: " +
          error.message
      )
    } finally {
      setLoadingPayment(false)
    }
  }

  const handleComplete = async transaction_id => {
    const user = JSON.parse(localStorage.getItem("user"))

    const updatedCombinedData = {
      key: subscribeKey,
      reference_no: bookingDetails?.reference_no,
      company_id: formData?.company_id,
      payment_type: paymentOption,
      transaction_id:
        paymentOption != "stripe-moto"
          ? transactionID
          : paymentOption == "stripe-moto"
          ? transaction_id
          : payment_intent,
      payment_intent_id: payment_intent,
      company_email: formData?.company_email === true ? "1" : "0",
      customer_email: formData?.customer_email === true ? "1" : "0",
      user_id: String(user?.id),
    }

    const completeResponse = await CompleteBooking(updatedCombinedData)
    if (completeResponse?.response_code === 200) {
      inComingIncompleteBooking({
        data: { reference_no: updatedCombinedData.reference_no },
        token: updatedCombinedData.key,
      })

      toast.success(completeResponse?.data)

      setSubmitLoading(false)
      setIncompleteModalOpen(false)
      navigate("/allBookings")
      setTimeout(() => {
        window.location.reload();
      }, 100); 
    } else {
      setLoadingPayment(false)
      setSubmitLoading(false)
      alert("Failed to amend booking. Please try again.")
    }
    setLoadingPayment(false)
    setSubmitLoading(false)
  }

  const handleWorldPay = async () => {
    const user = JSON.parse(localStorage.getItem("user"))
    setLoadingPayment(true)

    try {
      const response = await apiHandler({
        endpoint: "/backend/payment/create-worldpay-session",
        method: "POST",
        options: {
          "x-access-token": localStorage.getItem("token"),
        },
        data: {
          type: "incomplete",
          key: subscribeKey,
          extra_amount: extraCharges || 0,
          admin_charges: formData?.bookingFee,
          site_id: bookingDetails?.site_id,
          company_id: formData?.company_id,
          amount: totalAmount,
          sms_confirmation: formData?.sms ? "1" : "0",
          cancellation_status: formData?.cancellation ? "1" : "0",
          multi_mode_reference_no: bookingDetails?.multi_mode,
          reference_no: bookingDetails?.reference_no,
          payment_type: paymentOption,
          user_id: String(user?.id),
          name: `${formData?.firstName} ${formData?.lastName}`,
          email: formData?.email,
          contact_no: formData?.contactMobile,
          notify: `${domainUrl}/worldpay-notify?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
          response: `${domainUrl}/worldpay-response?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
          cancel: `${domainUrl}/worldpay-cancel?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
        },
      })

      if (response) {
        if (typeof window !== "undefined") {
          window.location.href = response?.data?.redirectUrl
          // console.log("host--------------", domainUrl);
        }
      }
    } catch (error) {
      setLoadingPayment(false)
      toast.error(error.response?.data?.message, { duration: 3000 })
    }
  }

 console.log(formData,"formData")

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        fullscreen
        style={{ fontSize: "11px" }}
      >
        <ModalHeader
          toggle={toggle}
          className="d-flex align-items-center fw-bold"
        >
          Incomplete Booking Edit
          <span className="ms-5" style={{ fontSize: "15px" }}>
            Reference No: {bookingDetails?.reference_no} | API Tag:{" "}
            {bookingDetails?.bookingDetails?.[0]?.company?.sku_tag}
          </span>
        </ModalHeader>

        {loading ? (
          <Loader />
        ) : (
          <ModalBody style={{ backgroundColor: "aliceblue" }}>
            <Form>
              <Row>
                <Col md="9" sm="12">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "10px",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Row className="d-flex  align-items-center">
                      <Col md={2} xs={12} style={getColStyle("14%")}>
                        <FormGroup>
                          <label htmlFor="airport">Airport *</label>
                          <Input
                            type="select"
                            name="airport"
                            id="airport"
                            value={formData?.airport}
                            onChange={handleAirportChange}
                            className="border-secondary"
                            style={{ fontSize: "11px" }}
                          >
                            {airports?.map(airport => (
                              <option key={airport?.id} value={airport?.code}>
                                {airport?.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={2} xs={12} style={getColStyle("17%")}>
                        <FormGroup>
                          <label htmlFor="company_id">Company *</label>
                          <Input
                            type="select"
                            name="company_id"
                            id="company_id"
                            value={formData?.company_id}
                            onChange={handleChange}
                            className="border-secondary"
                            style={{ fontSize: "11px" }}
                          >
                            <option value="">Select Company</option>
                            {availableCompanies?.map(company => (
                              <option key={company?.id} value={company?.id}>
                                {company?.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={2} xs={12} style={getColStyle("14%")}>
                        <FormGroup>
                          <label htmlFor="dropOffDate">Drop-Off Date *</label>
                          <DatePicker
                            selected={
                              formData?.dropOffDate
                                ? moment(
                                    formData?.dropOffDate,
                                    "DD/MM/YYYY"
                                  ).toDate()
                                : null
                            }
                            dateFormat="dd-MMM-yyyy"
                            onChange={date =>
                              setFormData(prev => ({
                                ...prev,
                                dropOffDate: moment(date).format("DD/MM/YYYY"),
                              }))
                            }
                            className="form-input f-11 border-secondary"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={1} xs={12} style={getColStyle("9%")}>
                        <FormGroup>
                          <label htmlFor="dropOffTime">Time *</label>
                          <DatePicker
                            selected={
                              formData?.dropOffTime
                                ? moment(
                                    formData?.dropOffTime,
                                    "HH:mm"
                                  ).toDate()
                                : null
                            }
                            onChange={time =>
                              setFormData(prev => ({
                                ...prev,
                                dropOffTime: moment(time).format("HH:mm"),
                              }))
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="HH:mm"
                            className="form-input f-11 border-secondary"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={1} xs={12} style={getColStyle("14%")}>
                        <FormGroup>
                          <label htmlFor="returnDate">Return Date *</label>
                          <DatePicker
                            selected={
                              formData?.returnDate
                                ? moment(
                                    formData?.returnDate,
                                    "DD/MM/YYYY"
                                  ).toDate()
                                : null
                            }
                            dateFormat="dd-MMM-yyyy"
                            onChange={date =>
                              setFormData(prev => ({
                                ...prev,
                                returnDate: moment(date).format("DD/MM/YYYY"),
                              }))
                            }
                            className="form-input f-11 border-secondary"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={1} xs={12} style={getColStyle("9%")}>
                        <FormGroup>
                          <label htmlFor="returnTime">Time *</label>
                          <DatePicker
                            selected={
                              formData?.returnTime
                                ? moment(formData?.returnTime, "HH:mm").toDate()
                                : null
                            }
                            onChange={time =>
                              setFormData(prev => ({
                                ...prev,
                                returnTime: moment(time).format("HH:mm"),
                              }))
                            }
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="HH:mm"
                            className="form-input f-11 border-secondary"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={1} xs={12} style={getColStyle("11%")}>
                        <FormGroup>
                          <label htmlFor="discountCode">Promo Code </label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.promoCode}
                            name="promoCode"
                            id="promoCode"
                            onChange={e =>
                              setFormData(prev => ({
                                ...prev,
                                promoCode: e.target.value,
                              }))
                            }
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={2} xs={12} style={getColStyle("12%")}>
                        <Button
                          color="warning"
                          size="xs"
                          className="f-11 mt-2"
                          onClick={handleGetQuote}
                          disabled={loadingQuote}
                          style={{
                            width: "90px",
                          }}
                        >
                          {loadingQuote ? <Spinner size="sm" /> : "Get Quote"}
                        </Button>
                      </Col>
                    </Row>
                    {/* {quoteData?.price && (
                      <>
                        <h5>Quote Details</h5>
                        {Number(quoteData.price) >
                        Number(formData?.quoteAmount) ? (
                          <div className="alert alert-success" role="alert">
                            New Amount {Number(quoteData.price).toFixed(2)} is
                            greater than Quoted Amount{" "}
                            {Number(formData?.quoteAmount).toFixed(2)} Please
                            update first then submit.
                          </div>
                        ) : (
                          <div className="alert alert-warning" role="alert">
                            New Amount {Number(quoteData.price).toFixed(2)} is
                            less than or equal to Quoted Amount{" "}
                            {Number(formData?.quoteAmount).toFixed(2)} Please
                            update first then submit.
                          </div>
                        )}
                      </>
                    )} */}
                    {quoteData?.price && (
                      <>
                        <h5>Quote Details</h5>
                        {Number(quoteData.price_before_discount) >
                        Number(formData?.quoteAmount) ? (
                          <div className="alert alert-success" role="alert">
                            New Amount{" "}
                            {Number(quoteData.price_before_discount).toFixed(2)}{" "}
                            is greater than Quoted Amount{" "}
                            {Number(formData?.quoteAmount).toFixed(2)}. Please
                            update first then submit.
                          </div>
                        ) : (
                          <div className="alert alert-warning" role="alert">
                            New Amount{" "}
                            {Number(quoteData.price_before_discount).toFixed(2)}{" "}
                            is less than or equal to Quoted Amount{" "}
                            {Number(formData?.quoteAmount).toFixed(2)}. Please
                            update first then submit.
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "10px",
                      borderRadius: "10px",
                      marginTop: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Row>
                      <Col md="1" style={getColStyle("10%")}>
                        <FormGroup>
                          <label for="title">Title *</label>
                          <Input
                            className="border-secondary"
                            type="select"
                            value={formData?.title}
                            onChange={handleChange}
                            name="title"
                            id="title"
                            style={{ fontSize: "11px" }}
                          >
                            <option>Mr.</option>

                            <option>Mrs.</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="2">
                        <FormGroup>
                          <label for="firstName">First Name *</label>
                          <Input
                            className=" border-secondary"
                            type="text"
                            value={formData?.firstName}
                            onChange={handleChange}
                            name="firstName"
                            id="firstName"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="2">
                        <FormGroup>
                          <label for="lastName">Last Name *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.lastName}
                            onChange={handleChange}
                            name="lastName"
                            id="lastName"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="2" style={getColStyle("14%")}>
                        <FormGroup>
                          <label for="contactMobile">Contact Mobile *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.contactMobile}
                            onChange={handleChange}
                            name="contactMobile"
                            id="contactMobile"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="3">
                        <FormGroup>
                          <label for="email">Email *</label>
                          <Input
                            className="border-secondary f-11"
                            type="email"
                            value={formData?.email}
                            onChange={handleChange}
                            name="email"
                            id="email"
                          />
                        </FormGroup>
                      </Col>
                      {bookingDetails?.bookingDetails[0]?.company?.type_id ==
                      1 ? (
                        ""
                      ) : (
                        <Col md="2">
                          <FormGroup>
                            <label for="no_of_peoples">No of Peoples</label>
                            <Input
                              className="border-secondary"
                              type="number"
                              name="no_of_peoples"
                              id="no_of_peoples"
                              value={formData?.no_of_peoples}
                              onChange={handleChange}
                              style={{ fontSize: "11px" }}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </div>

                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "10px",
                      borderRadius: "10px",
                      marginTop: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Row>
                      <Col md="3">
                        <FormGroup>
                          <label for="depTerminal">Depart Terminal *</label>
                          <Input
                            type="select"
                            name="depTerminal"
                            id="depTerminal"
                            value={formData?.depTerminal}
                            onChange={handleChange}
                            style={{ fontSize: "11px" }}
                            className="border-secondary"
                          >
                            {bookingDetails?.bookingDetails?.map(
                              (booking, index) =>
                                booking.airport?.terminal?.map(terminal => (
                                  <option
                                    key={`${index}-${terminal?.id}`}
                                    value={terminal?.name}
                                  >
                                    {terminal?.name}
                                  </option>
                                ))
                            )}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <label for="depFlight">Depart Flight *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.depFlight}
                            onChange={handleChange}
                            name="depFlight"
                            id="depFlight"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <label for="arrTerminal">Return Terminal *</label>
                          <Input
                            className="border-secondary"
                            type="select"
                            value={formData?.arrTerminal}
                            onChange={handleChange}
                            name="arrTerminal"
                            id="arrTerminal"
                            style={{ fontSize: "11px" }}
                          >
                            {bookingDetails?.bookingDetails?.map(
                              (booking, index) =>
                                booking.airport?.terminal?.map(terminal => (
                                  <option
                                    key={`${index}-${terminal?.id}`}
                                    value={terminal?.name}
                                  >
                                    {terminal?.name}
                                  </option>
                                ))
                            )}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <label for="arrFlight">Return Flight *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.arrFlight}
                            onChange={handleChange}
                            name="arrFlight"
                            id="arrFlight"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md="3">
                        <FormGroup>
                          <label for="make">Make *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.carMake}
                            onChange={handleChange}
                            name="carMake"
                            id="carMake"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <label for="carModel">Model *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.carModel}
                            onChange={handleChange}
                            name="carModel"
                            id="carModel"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <label for="carColor">Color *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.carColor}
                            onChange={handleChange}
                            name="carColor"
                            id="carColor"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <label for="carReg">Registration *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={formData?.carReg}
                            onChange={handleChange}
                            name="carReg"
                            id="carReg"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "10px",
                      borderRadius: "10px",
                      marginTop: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {" "}
                    <Row className="d-flex flex-md-row flex-column">
                      <Col>
                        <FormGroup>
                          <label for="quoteAmount">Quote Amount *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            name="quoteAmount"
                            value={
                              quoteData.price_before_discount
                                ? quoteData.price_before_discount
                                : formData?.quoteAmount
                            }
                            id="quoteAmount"
                            disabled
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <label for="extra">Extra *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            name="extraCharges"
                            id="extraCharges"
                            value={totalAmountDetail?.extra_charges || 0}
                            onChange={handleChange}
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <label for="discountAmount">Discount Amount *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            name="discountAmount"
                            value={
                              totalAmountDetail?.discount
                                ? totalAmountDetail?.discount
                                : quoteData?.discount
                            }
                            id="discountAmount"
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <label for="discountCode">Promo Code</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            name="discountCode"
                            value={
                              formData?.promoCode
                                ? formData?.promoCode
                                : discountCode
                            }
                            id="promoCode"
                            disabled
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <label for="bookingFee">Booking Fee *</label>
                          <Input
                            className="border-secondary"
                            type="text"
                            name="bookingFee"
                            value={formData?.bookingFee}
                            id="bookingFee"
                            disabled
                            style={{ fontSize: "11px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup check className="mb-2 mx-4">
                          <label check>
                            <Input
                              type="checkbox"
                              name="sms"
                              checked={formData?.sms}
                              onClick={handleCheckboxChange}
                              className="border-primary"
                              style={{ fontSize: "14px" }}
                            />{" "}
                            Add SMS Confirmation{" "}
                            {`(${bookingDetails?.site?.sms_charge})`}
                            <span
                              id="smsTooltip"
                              style={{
                                cursor: "pointer",
                                marginLeft: "5px",
                                backgroundColor: "grey",
                                borderRadius: "100%",
                                padding: " 0px 6px",
                                color: "white",
                              }}
                            >
                              ?
                            </span>
                            <Tooltip
                              placement="right"
                              isOpen={tooltipOpenSms}
                              target="smsTooltip"
                              toggle={toggleSmsTooltip}
                              style={{ fontSize: "11px" }}
                            >
                              This option adds SMS confirmation for your booking
                              at an additional cost of {`(${bookingDetails?.site?.sms_charge})`}.
                            </Tooltip>
                          </label>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup check className="mb-2 mx-4">
                          <label check>
                            <Input
                              type="checkbox"
                              name="cancellation"
                              checked={formData?.cancellation}
                              onClick={handleCheckboxChange}
                              className="border-primary"
                              style={{ fontSize: "14px" }}
                            />{" "}
                            Add Cancellation Cover{" "}
                            {`(${bookingDetails?.site?.cancellation_charge})`}
                            <span
                              id="cancellationTooltip"
                              style={{
                                cursor: "pointer",
                                marginLeft: "5px",
                                backgroundColor: "grey",
                                borderRadius: "100%",
                                padding: " 0px 6px",
                                color: "white",
                              }}
                            >
                              ?
                            </span>
                            <Tooltip
                              placement="right"
                              isOpen={tooltipOpenCancellation}
                              target="cancellationTooltip"
                              toggle={toggleCancellationTooltip}
                              style={{ fontSize: "11px" }}
                            >
                              This option adds cancellation cover for your
                              booking at an additional cost of {`(${bookingDetails?.site?.cancellation_charge})`}
                            </Tooltip>
                          </label>
                        </FormGroup>{" "}
                      </Col>
                    </Row>
                  </div>
                  <Button
                    color="primary"
                    size="sm"
                    style={{ width: "150px" }}
                    className="mb-3 me-4 mt-2"
                    onClick={handleUpdateIncomplete}
                    disabled={updateLoading}
                  >
                    {updateLoading ? <Spinner size="sm" /> : "Update"}
                  </Button>
                  <Button
                    color="warning"
                    size="sm"
                    className="mb-3 mt-2"
                    onClick={handleSendEmailToggle}
                  >
                    Send Email For Payment
                  </Button>
                  <CreateNotes bookingDetails={bookingDetails} />
                </Col>
                <Col md="3">
                  <div
                    className="border p-3"
                    style={{
                      backgroundColor: "#fff",
                      padding: "10px",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Row>
                      <Col>
                        <FormGroup>
                          <label for="totalAmount" style={{ fontSize: "15px" }}>
                            Total Amount *
                          </label>
                          <Input
                            className="border-secondary"
                            type="text"
                            value={Number(totalAmount).toFixed(2)}
                            name="totalAmount"
                            id="totalAmount"
                            disabled
                            style={{ fontSize: "15px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <StripeElement
                      public_key={public_key}
                      paymentOption={paymentOption}
                      setPaymentOption={setPaymentOption}
                      payment_intent={payment_intent}
                      clientSecret={clientSecret}
                      handleCreateIntent={handleCreateIntent}
                      transactionID={transactionID}
                      setTransactionID={setTransactionID}
                      setLoadingPayment={setLoadingPayment}
                      submitLoading={submitLoading}
                      apiTag={
                        bookingDetails?.bookingDetails[0]?.company?.sku_tag
                      }
                      setSubmitLoading={setSubmitLoading}
                      handleComplete={handleComplete}
                      formData={formData}
                    />
                    {bookingDetails?.bookingDetails[0]?.company?.sku_tag ==
                    "fhr" ? (
          <>
                      <Row>
                      <Col md={12}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              className="border-primary"
                              name="customer_email"
                              checked={formData?.customer_email}
                              onClick={handleCheckboxChange}
                              style={{ fontSize: "14px" }}
                            />{" "}
                            Send Customer Email
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              className="border-primary mb-4"
                              name="company_email"
                              checked={formData?.company_email}
                              onClick={handleCheckboxChange}
                              style={{ fontSize: "14px" }}
                            />{" "}
                            Send Company Email
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                      <Row>
                        <Col md={6}>
                          <Button
                            color="success"
                            size="sm"
                            disabled={totalAmount == 0 || submitLoading}
                            onClick={() => {
                              if (paymentOption === "") {
                                toast.error("Please select a payment option");
                                return;
                              }
                              if (paymentOption === "stripe-moto") {
                                setSubmitLoading(true);
                              }
                            }}
                            style={{
                              width: "130px",
                            }}
                          >
                             {submitLoading || loadingPayment ? (
          <div
            className="spinner-border text-light spinner-border-sm"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          "Submit Request"
        )}
      </Button>
      
    </Col>
    <Col>
                            <Button
                              color="danger"
                              block
                              size="sm"
                              onClick={toggle}
                            >
                              Cancel
                            </Button>
                          </Col>
  </Row>
  </>
                    ) : (
                      <>
                        {" "}
                        <Row>
                          <Col md={12}>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  className="border-primary"
                                  name="customer_email"
                                  checked={formData?.customer_email}
                                  onClick={handleCheckboxChange}
                                  style={{ fontSize: "14px" }}
                                />{" "}
                                Send Customer Email
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={12}>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  className="border-primary mb-4"
                                  name="company_email"
                                  checked={formData?.company_email}
                                  onClick={handleCheckboxChange}
                                  style={{ fontSize: "14px" }}
                                />{" "}
                                Send Company Email
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            {/* <Button
                              color="success"
                              size="sm"
                              disabled={
                                newTotalAmount != totalAmount || submitLoading
                              }
                              onClick={() => {
                                if (paymentOption == "worldpay") {
                                  handleWorldPay()
                                } else {
                                  if (paymentOption == "") {
                                    toast.error(
                                      "Please select a payment option"
                                    )
                                    return
                                  } else {
                                    setSubmitLoading(true)
                                  }
                                }
                              }}
                              style={{
                                width: "130px"
                              }}
                            >
                              {submitLoading || loadingPayment ? (
                                <div
                                  class="spinner-border text-light spinner-border-sm"
                                  role="status"
                                >
                                  <span class="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              ) : paymentOption == "worldpay" &&
                                transactionID == "" &&
                                !bookingDetails?.bookingDetails[0]?.company
                                  ?.sku_tag ? (
                                "World Pay"
                              ) : (
                                "Submit Request"
                              )}
                            </Button> */}
                            {/* <Button
                              color="success"
                              size="sm"
                              disabled={totalAmount == 0 || submitLoading}
                              onClick={() => {
                                if (paymentOption === "") {
                                  toast.error("Please select a payment option")
                                  return
                                }

                                if (paymentOption === "worldpay") {
                                  handleWorldPay()
                                } else {
                                  setSubmitLoading(true)
                                }
                              }}
                              style={{
                                width: "130px",
                              }}
                            >
                              {submitLoading || loadingPayment ? (
                                <div
                                  className="spinner-border text-light spinner-border-sm"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              ) : paymentOption === "worldpay" &&
                                transactionID === "" &&
                                !bookingDetails?.bookingDetails[0]?.company
                                  ?.sku_tag ? (
                                "World Pay"
                              ) : (
                                "Submit Request"
                              )}
                            </Button> */}

<Button
  color="success"
  size="sm"
  disabled={totalAmount == 0 || submitLoading}
  onClick={() => {
    if (paymentOption === "") {
      toast.error("Please select a payment option");
      return;
    }

    if (paymentOption === "worldpay") {
      handleWorldPay();
    } else {
      setSubmitLoading(true);
    }
  }}
  style={{
    width: "130px",
  }}
>
  {submitLoading || loadingPayment ? (
    <div
      className="spinner-border text-light spinner-border-sm"
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  ) : paymentOption === "worldpay" &&
    transactionID === "" &&
    bookingDetails?.bookingDetails[0]?.company?.sku_tag !== "fhr" &&
    bookingDetails?.bookingDetails[0]?.company?.sku_tag !== "a2z" ? (
    "World Pay"
  ) : (
    "Submit Request"
  )}
</Button>

                          </Col>
                          <Col>
                            <Button
                              color="danger"
                              block
                              size="sm"
                              onClick={toggle}
                            >
                              Cancel
                            </Button>
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </ModalBody>
        )}
      </Modal>
      <SendEmailModal
        isOpen={isEmailModalOpen}
        toggle={handleSendEmailToggle}
        emailData={formData}
      />
    </div>
  )
}

export default IncompleteBookingForm
